export const ratingsArray = [4.2, 3.0, 4.5, 5.0, 3.3, 2.0, 4.1, 4.7].map(
	String
);
